module.exports = __webpack_public_path__ + "static/media/unlock.fb18305a.svg";